import axios from 'axios';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

const session = axios.create({
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME,
});

// Check and set Authorization token
if (localStorage.getItem('token')) {
    session.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;
} else {
    session.defaults.headers.common.Authorization = null;
}

// Check token and remove when 401
session.interceptors.response.use((response) => {
    return response;
}, (err) => {
    if (err.response.status === 401 && localStorage.getItem('token')) {
        localStorage.removeItem('token');
    }
    throw err;
});

if (process.env.VUE_APP_API_BASE_URL) {
    session.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
} else if (window.origin.includes('dev') || window.origin.includes('localhost') || window.origin.includes('127.0.0.1')) {
    session.defaults.baseURL = 'https://dev.api-lockerbot.com/admin/v1/';
} else {
    session.defaults.baseURL = 'https://api-lockerbot.com/admin/v1/';
}

// This is ONE shared instance for the whole app, and the SPA never reloads — anything
// written to `session.defaults` persists for the rest of the user's session. Never set a
// top-level `session.defaults.headers[...]` or a per-method one
// (`session.defaults.headers.post[...]`): both are merged over `headers.common` and reach
// every later request. A leftover 'multipart/form-data' in particular makes axios silently
// re-encode later plain-object bodies as multipart, mangling nested/list fields and
// dropping nulls — see the CLAUDE.md entry for the outage this caused.
// To upload a file, build a real FormData and pass it as the request body — axios drops
// Content-Type for FormData by itself. For a one-off header, use the per-request config;
// only `headers.common` (auth, below) is meant to be written here.
// Enforced by `no-restricted-syntax` in package.json.
export default session;
